import {Checkbox, CheckboxProps} from "@progress/kendo-react-inputs";
import {useEffect, useState} from "react";

export default function FlintCheckBox(props: FlintCheckboxProps) {
    const [labelClassNameLocal, setLabelClassNameLocal] = useState<string | undefined>(props.labelClassName);
    const {size = "large", rounded = "small", labelClassName, ...other} = props;
    return <div className={"flint-checkbox"}>
        <Checkbox {...other} size={size} labelClassName={labelClassNameLocal} rounded={rounded}/>
    </div>
}

export interface FlintCheckboxProps extends CheckboxProps {

}